const { styled } = require('@mui/material');

export const StyledSetting = styled('div')``;
